import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import RecommendationCreate from '/@/components/recommendation-create';
import FieldSelect from '/@/components/recommendation-create/bayer/fields-step';
import { _ } from '/@/locale';
import type { Field } from '/@/types/field';
import type { Step } from '/@/types/recommendation-create';
import { reverse } from '/@/utils/router';

function RecommendationFieldSelect({ crop = 'corn' }: { crop?: string }) {
    const { search } = useLocation();
    const query = new URLSearchParams(search);
    const entrySource = query.get('entrySource');
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState<number>(0);
    const [field, setField] = useState<Field | undefined>(undefined);

    const steps: Step[] = [
        {
            sidebarName: _('Selección de lote'),
            recommendationType: _('Recomendación de semilla'),
            title: _('Elegí el lote para generar la recomendación'),
            subtitle: _('Seleccioná un lote para obtener una recomendación ajustada a sus condiciones específicas.'),
            content: (
                <FieldSelect
                    field={field}
                    setField={(field) => {
                        setField(field);
                    }}
                />
            ),
            onClickNext: () => {
                navigate(
                    reverse('recommendations.RecommendationEdit', {
                        qs: { entrySource: entrySource },
                        params: { crop, fieldId: field?.id },
                    })
                );
            },
            onClickNextDisabled: () => field === undefined,
            onClickBackDisabled: () => true,
        },
        {
            sidebarName: _('Fecha de siembra'),
            content: '',
        },
    ];
    return RecommendationCreate({ steps, activeStep, setActiveStep });
}

export default RecommendationFieldSelect;
